import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Alert } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { RootState } from 'redux/store'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../../styles'
import { warningImg } from '../../utils'

const AlertUserStatusWarningComponent = ({ handleClose }: { handleClose: () => void }) => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()

    const { currentUser } = useSelector((state: RootState) => state.user)

    useEffect(() => {
        if (!currentUser?.isCompany && currentUser?.kycStatus !== 'Verified') {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [currentUser])

    const buttonHandler = () => {
        handleClose()
        navigate('/settings/documents')
    }

    return (
        <FadeAnimationDiv>
            <ThemeProvider theme={formTheme}>
                <Collapse in={open} timeout={500}>
                    <Alert icon={false} className="warning userWarning">
                        <div className="iconBox">
                            <img className="iconImg" src={warningImg} alt={t('Alert.Warning')} />
                        </div>
                        <div className="message userWarning">
                            <span className="text">
                                {t('Alert.AlertUserStatusWarning.Disclaimer')}{' '}
                                <span style={{ fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={buttonHandler}>
                                    {t('Alert.AlertUserStatusWarning.GoToDocuments')}
                                </span>
                            </span>
                        </div>
                    </Alert>
                </Collapse>
            </ThemeProvider>
        </FadeAnimationDiv>
    )
}

export default AlertUserStatusWarningComponent
